// File: lib/errors/CustomError.ts
export class CustomError extends Error {
  public showToClient: boolean;

  constructor(message: string, showToClient = false) {
    super(message);
    this.showToClient = showToClient;
  }
}
